import { useState } from 'react';
import { FaUserFriends, FaBook, FaCog, FaCalculator, FaCreditCard, FaMoneyBillWave, FaExternalLinkAlt } from 'react-icons/fa';
import styles from "./documentacion.module.css";
import WindowLayout from '../utils/layout/windowsLayout';



export default function Documentacion() {
    const [selectedCategory, setSelectedCategory] = useState('all');
    
    // Documentos organizados por categorías
    const documentCategories = {
        catalogos: {
            title: 'Catálogos',
            icon: <FaBook className={styles.categoryIcon} />,
            color: '#4CAF50',
            documents: [
                {
                    title: 'Catálogos del Sistema',
                    description: 'Gestión completa de catálogos: asesores, sucursales, usuarios y configuraciones.',
                    url: 'https://1drv.ms/w/c/1f3256eb54e66c05/EWsbvIwfo5ZImV4DqWrJaR8BPRsnoBUwaSKb6hb-K8xJKw?e=ylB42j',
                    icon: <FaBook />
                }
            ]
        },
        configuraciones: {
            title: 'Configuraciones',
            icon: <FaCog className={styles.categoryIcon} />,
            color: '#FF9800',
            documents: [
                {
                    title: 'Configuraciones del Sistema',
                    description: 'Parámetros generales, roles de usuario y configuraciones avanzadas del sistema.',
                    url: 'https://1drv.ms/w/c/1f3256eb54e66c05/EQjfNbRt3cNOnEgnBMHjfPMBJ6_NBu9nQ8BExAD2y1_rKA?e=aP1jDX',
                    icon: <FaCog />
                }
            ]
        },
        operaciones: {
            title: 'Operaciones',
            icon: <FaCalculator className={styles.categoryIcon} />,
            color: '#2196F3',
            documents: [
                {
                    title: 'Corte de Caja',
                    description: 'Procedimientos para realizar cortes de caja, balances diarios y reportes financieros.',
                    url: 'https://1drv.ms/w/c/1f3256eb54e66c05/EUOZOXHyt5FGkUNSxyEMhKIBK2nqHI8IBeudWuheuI2_Fg?e=wkW3FG',
                    icon: <FaCalculator />
                }
            ]
        },
        financiero: {
            title: 'Financiero',
            icon: <FaMoneyBillWave className={styles.categoryIcon} />,
            color: '#9C27B0',
            documents: [
                {
                    title: 'Gestión de Pagos',
                    description: 'Procesos de cobros, abonos, recuperaciones y gestión de cartera vencida.',
                    url: 'https://1drv.ms/w/c/1f3256eb54e66c05/EdQmOmxdJltGqh-MKrRMsr8Ba-r26liN_3dwCUoOvPxzJA?e=3l2Jl3',
                    icon: <FaCreditCard />
                },
                {
                    title: 'Gestión de Préstamos',
                    description: 'Originación de créditos, tablas de amortización, seguimiento y administración de préstamos.',
                    url: 'https://1drv.ms/w/c/1f3256eb54e66c05/EfxvLaaTaglLquVvETkIPY0BhsGGzkIWtXRY07Wnfyoq0w?e=5NxTtY',
                    icon: <FaMoneyBillWave />
                }
            ]
        }
    };

    // Filtrar documentos por categoría
    const getFilteredDocuments = () => {
        let allDocuments = [];
        
        Object.keys(documentCategories).forEach(categoryKey => {
            const category = documentCategories[categoryKey];
            if (selectedCategory === 'all' || selectedCategory === categoryKey) {
                category.documents.forEach(doc => {
                    allDocuments.push({
                        ...doc,
                        category: categoryKey,
                        categoryTitle: category.title,
                        categoryColor: category.color
                    });
                });
            }
        });

        return allDocuments;
    };

    const openDocument = (url, title) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    return (
        <WindowLayout
            title="DOCUMENTACIÓN"
            route={["Documentación"]}
            icon={<FaUserFriends />}
        >
            <div className={styles.documentationContainer}>
                {/* Header con filtros */}
                <div className={styles.headerSection}>
                    <div className={styles.headerContent}>
                        <div className={styles.headerText}>
                            <h2>Centro de Documentación</h2>
                            <p>Accede a toda la documentación del sistema financiero</p>
                            
                            {/* Resumen compacto de categorías */}
                            <div className={styles.categoriesSummary}>
                                {Object.keys(documentCategories).map(categoryKey => {
                                    const category = documentCategories[categoryKey];
                                    return (
                                        <div key={categoryKey} className={styles.summaryItem}>
                                            <span className={styles.summaryIcon} style={{ color: category.color }}>
                                                {category.icon}
                                            </span>
                                            <span className={styles.summaryText}>
                                                {category.title}: {category.documents.length} doc{category.documents.length !== 1 ? 's' : ''}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className={styles.filterContainer}>
                            <select
                                value={selectedCategory}
                                onChange={(e) => setSelectedCategory(e.target.value)}
                                className={styles.categoryFilter}
                            >
                                <option value="all">Todas las categorías</option>
                                <option value="catalogos">Catálogos</option>
                                <option value="configuraciones">Configuraciones</option>
                                <option value="operaciones">Operaciones</option>
                                <option value="financiero">Financiero</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* Lista de documentos */}
                <div className={styles.documentsGrid}>
                    {getFilteredDocuments().map((doc, index) => (
                        <div key={index} className={styles.documentCard}>
                            <div className={styles.documentHeader}>
                                <div className={styles.documentIcon} style={{ color: doc.categoryColor }}>
                                    {doc.icon}
                                </div>
                                <div className={styles.documentMeta}>
                                    <span className={styles.documentCategory} style={{ color: doc.categoryColor }}>
                                        {doc.categoryTitle}
                                    </span>
                                    <h4 className={styles.documentTitle}>{doc.title}</h4>
                                </div>
                            </div>
                            
                            <p className={styles.documentDescription}>{doc.description}</p>
                            
                            <div className={styles.documentActions}>
                                <button
                                    onClick={() => openDocument(doc.url, doc.title)}
                                    className={styles.documentButton}
                                    style={{ backgroundColor: doc.categoryColor }}
                                >
                                    <FaExternalLinkAlt />
                                    Abrir Documento
                                </button>
                            </div>
                        </div>
                    ))}
                </div>


            </div>
        </WindowLayout>
    );
} 